export class AbortedError extends Error {
  constructor() {
    super('AbortedError');
  }
}